'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetAvailabilityOptions = undefined;

var _reselect = require('reselect');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var _getAvailabilityOptions = require('../operators/getAvailabilityOptions');

var getWidgetAvailabilityOptions = exports.getWidgetAvailabilityOptions = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], _getAvailabilityOptions.getAvailabilityOptions);